import { render, staticRenderFns } from "./HomeViewTwo.vue?vue&type=template&id=32952d66&scoped=true"
import script from "./HomeViewTwo.vue?vue&type=script&lang=js"
export * from "./HomeViewTwo.vue?vue&type=script&lang=js"
import style0 from "./HomeViewTwo.vue?vue&type=style&index=0&id=32952d66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32952d66",
  null
  
)

export default component.exports